import { IFixtures } from '../types'
import RawData from './data.json'

const FIXTURES = RawData as IFixtures

export default FIXTURES
